import { render } from "./KappKalenderMonth.vue?vue&type=template&id=fa580c16"
import script from "./KappKalenderMonth.vue?vue&type=script&lang=js"
export * from "./KappKalenderMonth.vue?vue&type=script&lang=js"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__